import { ListItem } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import TableListItemColumn from 'components/Table/components/TableItem/components/TableListItem/components/TableListItemColumn';
import useStyles from 'components/Table/components/TableItem/components/TableListItem/TableListItem.styles';
import { IColumn } from 'components/Table/types/Table';

type TableListItemProps = {
  item: any;
  columns: IColumn[];
  keyName: string;
  handleRowClick: ((event: any, x?: any) => void) | undefined;
  isExpanded: boolean;
  expandOnClick: boolean | undefined;
  tableItemGridTemplate: string;
};

const TableListItem = ({
  item,
  columns,
  keyName,
  handleRowClick,
  isExpanded,
  expandOnClick,
  tableItemGridTemplate,
}: TableListItemProps) => {
  const classes = useStyles({
    tableItemGridTemplate,
    rowIsClickable: !!(handleRowClick || expandOnClick),
  });

  const handleItemClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (handleRowClick) {
      handleRowClick(event, item);
    }
  };

  return (
    <ListItem
      divider
      className={classes.item}
      onClick={handleItemClick}
      aria-label={`listItem-${item[keyName]}`}
    >
      {columns.map((column, index) => (
        <TableListItemColumn
          key={`listItemText-${item[keyName]}-${index}`}
          item={item}
          column={column}
          isExpanded={isExpanded}
        />
      ))}
    </ListItem>
  );
};

export default TableListItem;
